"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CardDate_component_exports = {};
__export(CardDate_component_exports, {
  CardDate: () => CardDate,
  default: () => CardDate_component_default
});
module.exports = __toCommonJS(CardDate_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_atoms = require("../../../atoms");
var import_useBreakpoints = require("../../../../utils/useBreakpoints/useBreakpoints.hook");
var _templateObject;
var _excluded = ["header", "date", "time"];
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var CardDate = function CardDate2(_ref) {
  var header = _ref.header, date = _ref.date, time = _ref.time, props = _objectWithoutProperties(_ref, _excluded);
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var is400percent = breakpoints.isSm || breakpoints.isXs;
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, _extends({}, props, {
    $_css: [{
      "display": "flex",
      "height": "100%",
      "minHeight": "96px",
      "width": "108px",
      "alignItems": "center",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(242 244 237 / var(--tw-bg-opacity))",
      "hyphens": "auto"
    }, is400percent && {
      "width": "100%",
      "borderTopRightRadius": "0.5rem"
    }]
  }), /* @__PURE__ */ import_react.default.createElement(_StyledSpan, null, props["aria-label"]), /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, {
    "aria-hidden": true
  }, /* @__PURE__ */ import_react.default.createElement(import_atoms.Text, {
    baseStyle: "text2"
  }, header), /* @__PURE__ */ import_react.default.createElement(import_atoms.Text, {
    baseStyle: "heading2",
    weight: "bold"
  }, date), /* @__PURE__ */ import_react.default.createElement(import_atoms.Text, {
    size: "extraSmall",
    baseStyle: "text2"
  }, time)));
};
var CardDate_component_default = CardDate;
var _StyledDiv = (0, import_styled_components.default)("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledSpan = (0, import_styled_components.default)("span")({
  "position": "absolute",
  "width": "1px",
  "height": "1px",
  "padding": "0",
  "margin": "-1px",
  "overflow": "hidden",
  "clip": "rect(0, 0, 0, 0)",
  "whiteSpace": "nowrap",
  "borderWidth": "0"
});
var _StyledDiv2 = (0, import_styled_components.default)("div").withConfig({
  displayName: "CardDatecomponent___StyledDiv2",
  componentId: "sc-15s36zv-0"
})({
  "marginLeft": "1rem",
  "marginRight": "0.125rem",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.125rem",
  "--tw-text-opacity": "1",
  "color": "rgb(51 51 51 / var(--tw-text-opacity))"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardDate
});
//# sourceMappingURL=CardDate.component.js.map